import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon } from 'lucide-react';
import { essentialTools } from '../data/tools';
export function ToolsSection() {
  return <section className="py-24 px-4 bg-carbon-graphite" data-id="element-315" data-mp="3njahikfs1x2c">
      <div className="max-w-5xl mx-auto" data-id="element-316" data-mp="3nisd30iyocjc">
        <div className="text-center mb-16" data-id="element-317" data-mp="3jhowucx04ehl">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-3" data-id="element-318" data-mp="3jj010duczo98">
            The <span className="text-gold" data-id="element-319" data-mp="2vt5qi2xiibs5">2 Essential Teaching Tools</span>
          </h2>
          <p className="text-lg text-mist" data-id="element-320" data-mp="2qtt41jajz6q3">
            Included as part of the 6-in-1 system — not sold separately anywhere.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-321" data-mp="34qpu3iiukk5x">
          {essentialTools.map((tool, index) => <motion.article key={tool.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className="bg-carbon border border-gold/30 rounded-2xl p-8 flex flex-col" data-id="element-322" data-mp="2zvtxe52o18mh" data-mpi={index}>
              <div className="w-12 h-12 border border-gold rounded-full flex items-center justify-center text-gold mb-6" data-id="element-323" data-mp="2m6c9d4jj22g2">
                <WrenchIcon size={22} data-id="element-324" data-mp="2r7jfz09xovl5" />
              </div>
              <div className="text-gold font-bold text-sm uppercase tracking-wider mb-1" data-id="element-325" data-mp="2w636ldzh2vju">
                {tool.label}
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 text-white" data-id="element-326" data-mp="1yjvznxfp4r4b">{tool.title}</h3>
              <p className="text-white/80 text-sm italic mb-5 border-l-2 border-gold pl-4" data-id="element-327" data-mp="23hp34ipm770w">
                {tool.subtitle}
              </p>
              <div className="space-y-4 mb-6 flex-grow" data-id="element-328" data-mp="2d6p6eeb5gokw">
                {tool.paragraphs.map(paragraph => <p key={paragraph} className="text-mist text-sm leading-relaxed" data-id="element-329" data-mp="1fs39sbvxbm0t">
                    {paragraph}
                  </p>)}
              </div>
              <p className="text-white text-sm font-semibold border-t border-gold/30 pt-4" data-id="element-330" data-mp="1cpyq82urrftw">
                {tool.benefit}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}